module.exports = __webpack_public_path__ + "img/package.28475611.svg";